// 这是一个用来配置pageview事件的配置表
// 只能配置router定义过的path，router.tsx

export const pageViewConfigList = [
  {
    page_url: '',
    page_name: 'web3_staking_page',
  },
];

export const Event = {
  Web3PageView: 'Web3PageView',
  Web3UserClick: 'Web3UserClick',
};

export const Page = {
  StakingWebHomepage: 'StakingWeb_homepage',
  PoolDetail: 'StakingWeb_Pool_Detail',
  Disclaimer: 'StakingWeb_disclaimer_view',
  StakingInitial: 'StakingWeb_stake_initiat',
  StakingDetail: 'StakingWeb_stake_detail',
  StakingResult: 'StakingWeb_stake_orderresult',
  StakingTokenChose: 'StakingWeb_Stake_Tokenchose',
  RedeemInitial: 'StakingWeb_redeem_initiat',
  RedeemDetail: 'StakingWeb_redeem_detail',
  RedeemResult: 'StakingWeb_redeem_orderresult',
  RedeemDelay: 'StakingWeb_redeem_delay',
  ClaimInitial: 'StakingWeb_rewards_initiat',
  WithDrawInitial: 'StakingWeb_principal_withdrawal',
  SmallIncome: 'StakingWeb_Smallincome_view',
};
